<template>
  <main class="landing">
    <section class="hero-section">
      <WideHighlightContainer />
    </section>

    <section class="feature-section">
      <div class="section-header">
        <p class="eyebrow">Neden OCN</p>
        <h2>Toprağa, tohuma ve üreticiye aynı anda değer</h2>
        <p class="section-lead">
          Bölgesel ihtiyaçlara uygun gübre formülasyonları, May Tohum Karadeniz distribütörlüğü ve sahada teknik destekle
          çiftçimizin yanında duruyoruz.
        </p>
      </div>
      <div class="feature-grid">
        <div v-for="feature in features" :key="feature.title" class="feature-card">
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.copy }}</p>
        </div>
      </div>
    </section>

    <section class="partnership-section">
      <div class="partnership-copy">
        <p class="eyebrow">May Tohum</p>
        <h2>Karadeniz distribütörlüğüyle güçlü tohum portföyü</h2>
        <p class="section-lead">
          May Tohum'un tarla bitkileri ve sebze çeşitlerini, OCN Gübre'nin besleme programı ve bölgesel saha deneyimiyle
          birlikte üreticiye sunuyoruz.
        </p>
        <router-link to="/tohumlar" class="partnership-link">Tohumları İncele</router-link>
      </div>
      <div class="partnership-visual">
        <img src="/may-tohum/may-logo.png" alt="May Tohum" class="may-logo" />
        <img src="/may-tohum/may-hero-sunflower.jpg" alt="Ayçiçeği tarlası" class="field-image" />
      </div>
    </section>

    <section class="tiles-section">
      <div class="section-header">
        <p class="eyebrow">Ürün ailelerimiz</p>
        <h2>Gübre ve tohumda tamamlayıcı çözümler</h2>
        <p class="section-lead">
          Bitki, toprak ve bölge ihtiyacına göre şekillenen dengeli içerikler ile May Tohum çeşitlerini aynı çatı altında
          inceleyin.
        </p>
      </div>
      <ProductTilesContainer />
    </section>
  </main>
</template>

<script>
import ProductTilesContainer from './ProductTilesContainer.vue';
import WideHighlightContainer from './WideHighlightContainer.vue';

export default {
  name: 'LandingPage',
  components: {
    WideHighlightContainer,
    ProductTilesContainer
  },
  data() {
    return {
      features: [
        {
          title: 'Bilimsel içerik',
          copy: 'Toprak ve yaprak analizleriyle dengeli besleme; her partide kalite kontrol.'
        },
        {
          title: 'Sahada destek',
          copy: 'Uygulama zamanı, doz, çeşit seçimi ve sezon takibi için teknik danışmanlık.'
        },
        {
          title: 'May Tohum gücü',
          copy: 'Karadeniz distribütörlüğüyle güçlü tohum portföyünü gübre uzmanlığımızla birleştiriyoruz.'
        }
      ]
    };
  }
};
</script>

<style scoped>
.landing {
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 28px 0 56px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  min-height: 100vh;
}

.hero-section,
.feature-section,
.partnership-section,
.tiles-section {
  width: var(--page-width);
  margin: 0 auto;
  box-sizing: border-box;
}

.section-header {
  text-align: left;
  margin-bottom: 18px;
  color: #0f172a;
}

.section-header h2 {
  margin: 4px 0;
  font-size: 26px;
}

.section-lead {
  margin: 0;
  color: #1f2937;
  max-width: 760px;
  line-height: 1.6;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 800;
  color: #0f766e;
}

.eyebrow::before {
  content: '';
  width: 18px;
  height: 2px;
  background: #0f766e;
  border-radius: 999px;
}

.feature-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
}

.feature-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  color: #0f172a;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
}

.feature-card h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.feature-card p {
  margin: 0;
  color: #334155;
  line-height: 1.55;
}

.partnership-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 24px;
  align-items: center;
  background: #0f172a;
  color: #ffffff;
  border-radius: 16px;
  padding: 26px;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.18);
}

.partnership-copy {
  text-align: left;
  display: grid;
  gap: 10px;
}

.partnership-copy h2 {
  margin: 0;
  font-size: 28px;
}

.partnership-copy .section-lead {
  color: #dbeafe;
}

.partnership-link {
  width: fit-content;
  text-decoration: none;
  background: #b8e04a;
  color: #102a12;
  border: 1px solid #b8e04a;
  border-radius: 10px;
  padding: 12px 16px;
  font-weight: 800;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.partnership-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(184, 224, 74, 0.2);
}

.partnership-visual {
  position: relative;
  min-height: 220px;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
}

.field-image {
  width: 100%;
  height: 100%;
  min-height: 220px;
  object-fit: cover;
  display: block;
}

.may-logo {
  position: absolute;
  top: 14px;
  left: 14px;
  width: 88px;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px;
  z-index: 1;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
}

.tiles-section {
  display: grid;
  gap: 12px;
}

@media (max-width: 720px) {
  .landing {
    gap: 36px;
    padding: 18px 0 44px;
  }

  .feature-section {
    padding: 18px;
  }

  .partnership-section {
    grid-template-columns: 1fr;
    padding: 20px;
  }

  .partnership-visual {
    min-height: 180px;
  }

  .field-image {
    min-height: 180px;
  }
}
</style>
